import { render, staticRenderFns } from "./ViewNoteInternalComponent.vue?vue&type=template&id=8895fe44"
import script from "./ViewNoteInternalComponent.vue?vue&type=script&lang=js"
export * from "./ViewNoteInternalComponent.vue?vue&type=script&lang=js"
import style0 from "./ViewNoteInternalComponent.vue?vue&type=style&index=0&id=8895fe44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports